module.exports = __webpack_public_path__ + "img/nmg.1dcbcf22.png";